import Typography from '@components/atoms/Typography';
import ContentBox from '@components/atoms/ContentBox';
import { FormattedMessage } from 'utils/intl';

import CaseStudyCheckList from './components/CaseStudyCheckList';
import classes from './ProsAndCons.module.scss';
import messages from './ProsAndCons.messages';
import Props from './ProsAndCons.types';

const ProsAndCons = ({
  className,
  title,
  descriptionFirstPart,
  descriptionSecondPart,
  consSection,
  firstPros,
  secondPros,
  numbersSection,
}: Props): JSX.Element => (
  <div className={className}>
    <Typography variant="h1" renderAs="div" className={classes.header}>
      <FormattedMessage {...messages.header} />
    </Typography>
    <ContentBox variant="lightBlue" className={classes.gradientBox}>
      <Typography variant="h1" renderAs="div" className={classes.description}>
        {title}
      </Typography>
    </ContentBox>
    <div className={classes.firstWrapper}>
      <Typography variant="h2" renderAs="div" className={classes.smallDescription}>
        <div>{descriptionFirstPart}</div>
        <div>{descriptionSecondPart}</div>
      </Typography>
    </div>
    {consSection && <CaseStudyCheckList {...consSection} variant="minus" />}
    {firstPros && <CaseStudyCheckList {...firstPros} variant="minus" />}
    {secondPros && <CaseStudyCheckList {...secondPros} />}
    {numbersSection && (
      <>
        <div className={classes.wrapper}>
          <div className={classes.sectionTitleWrapper}>
            <Typography variant="h1" renderAs="span" className={classes.sectionTitle}>
              {numbersSection.title}
            </Typography>
          </div>
        </div>
        <div className={classes.numbers}>
          {numbersSection.numbers.map((number, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={classes.numberWrapper}>
              <div className={classes.number}>
                {number.value}
                {number.type === 'percent' && <span className={classes.percent}>%</span>}
              </div>
              <Typography variant="body1" className={classes.numberDescription}>
                {number.description}
              </Typography>
            </div>
          ))}
        </div>
      </>
    )}
  </div>
);

export default ProsAndCons;
